module.exports = __webpack_public_path__ + "img/repeat-1.8eb94836.svg";